import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { WebapiService } from '../shared/services/webapi.service';
import { UserInfo } from '../store/actions/user.action';
import { AppState } from '../store/app.states';

@Component({
  selector: 'app-payment-cancel',
  templateUrl: './payment-cancel.component.html',
  styleUrls: ['./payment-cancel.component.scss']
})
export class PaymentCancelComponent {
  redirectScheduled=false;
  constructor(public webApi: WebapiService, private store: Store<AppState>, private router: Router) {}

  ngOnInit() {
    this.handleCheckoutReturnCode();
    if(this.webApi.isLoggedIn()){
      this.scheduleVideoRedirect();
    }
  }

  handleCheckoutReturnCode(){
    const searchParams = new URLSearchParams(window.location.search || '');
    let code = searchParams.get('rcode') || '';
    if(!code){
    const hash = (window.location.hash || '').replace('#', '');
    if(!hash){
      return;
    }
    const params = new URLSearchParams(hash);
      code = params.get('code') || '';
    }
    if(!code){
      return;
    }
    this.webApi.exchangeCheckoutReturn(code).subscribe((data: any) => {
      if(data && data.success && data.token){
        this.webApi.setSession(data);
        this.store.dispatch(new UserInfo());
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        this.scheduleVideoRedirect();
      }
    });
  }

  scheduleVideoRedirect(){
    if(this.redirectScheduled){
      return;
    }
    this.redirectScheduled = true;
    setTimeout(()=>{
      this.router.navigateByUrl('/video');
    },2500);
  }

}
